import React, { Component } from "react"
import { connect } from "react-redux"
import styles from "./styles.css"
import BigList from "../../components/BigList"
import Button from "react-toolbox/lib/button/Button"
import { withActions, formatDateTime, formatCurrency } from "../../utils"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import * as strings from "../../strings"
import BillingOrderDialog from "./BillingOrderDialog"
import { toastr } from "react-redux-toastr"
import Dialog from "react-toolbox/lib/dialog"

const BILLING_ORDERS_COLUMNS = [ {
  title: strings.generalStrings.creationDate,
  key: "createdAt",
  transform: createdAt => formatDateTime( createdAt ),
}, {
  title: strings.processes.processType,
  key: "debtPhase",
  transform: x => strings.DebtPhaseTranslation[ x ],
}, {
  title: "Tipo de Ordem",
  key: "initialBillingOrderType",
}, {
  title: strings.generalStrings.billingPhase,
  key: "billingPhase",
  transform: x => strings.BillingPhaseTranslation[ x ],
}, {
  title: strings.generalStrings.client,
  key: "clientName",
}, {
  title: strings.invoices.invoiceNumber,
  key: "invoiceNumber",
}, {
  title: strings.invoices.invoiceDate,
  key: "invoiceDate",
  transform: invoiceDate => formatDateTime( invoiceDate ),
}, {
  title: strings.invoices.value,
  key: "value",
  transform: value => value
    ? formatCurrency( value )
    : "",
} ]

class BillingOrder extends Component {
  props: {
    value: mixed,
    onChange: ( mixed ) => any,
    actions: mixed,
    store: mixed,
    history: mixed,
  }

  state = {
    editIdBillingOrder: null,
    deleteIdBillingOrder: null,
  }

  componentDidMount () {
    this.props.actions.getAllBillingOrders()
  }

  getSortedBillingOrders = () => _.chain( this.props )
    .get( "billingOrders", [] )
    .orderBy( [ "createdAt" ], [ "desc" ] )
    .value()

  onEdit = ( { id } ) => this.setState( {
    editIdBillingOrder: id,
  } )

  onDelete = (instance) => {
    if (instance.invoiceNumber || instance.invoiceDate) {
      return toastr.error("Esta ordem de faturação ja tem uma fatura associada");
    }

    this.setState({
      deleteIdBillingOrder: instance.id,
    });
  }

  deleteBillingOrder = () => {
    this.props.actions.deleteBillingOrder(this.state.deleteIdBillingOrder)
      .then(() => toastr.success("Ordem de faturação apagada"))
      .catch(() => toastr.success("Erro a apagar ordem de faturação"))
      .finally(this.hideDialog)
  }

  hideDialog = () => this.setState( {
    editIdBillingOrder: null,
    deleteIdBillingOrder: null,
  } )


  render () {
    const billingOrders = this.getSortedBillingOrders()

    return (
      <div className={styles.root}>
        <div className={styles.toolbar}>
          <Button
            icon="add"
            onClick={() => this.props.history.push( "createBillingOrder/" )}
            label={strings.billingOrders.createBillingOrder}
            raised
            primary
          />
        </div>
        <BigList
          loadMore={() => {}}
          hasMoreItems={() => {}}
          items={billingOrders}
          columns={BILLING_ORDERS_COLUMNS}
          columnPadding={10}
          onModify={this.onEdit}
          onDelete={this.onDelete}
        />
        <BillingOrderDialog
          idBillingOrder={this.state.editIdBillingOrder}
          visible={this.state.editIdBillingOrder !== null}
          hideDialog={this.hideDialog}
        />
        <Dialog
          active={this.state.deleteIdBillingOrder !== null}
          onEscKeyDown={this.hideDialog}
          onOverlayClick={this.hideDialog}
          actions={ [
            { label: strings.generalStrings.cancel, onClick: this.hideDialog },
            { label: strings.generalStrings.delete, onClick: this.deleteBillingOrder },
          ]}
          title="Tem a certeza que deseja apagar esta ordem de faturação?"
        />
      </div>
    )
  }
}

export default connect(
  store => _.pick( store, [ "billingOrders" ] )
)( withActions( withRouter( BillingOrder ) ) )



// WEBPACK FOOTER //
// ./src/views/BillingOrders/index.jsx